<template>
    <div class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/AppAlarm')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSteps('ruleForm')"
            >
             提交
           </el-button>
            </div>
            <div class="edit-from">
                 <div class="public-tit flex align-cen">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  基础信息
                    </div>
              </div>
               <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                  <el-form-item label="报警规则名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入您的报警规则名称【1-20】" clearable></el-input>
                 </el-form-item>
                  <el-form-item label="报警分类：" prop="classifyId">
                    <el-select v-model="form.classifyId" placeholder="选择报警分类" clearable @change="getAppid">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.appName + '--' + item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                  <el-form-item label="报警级别：" prop="alarmLevel">
                    <el-select v-model="form.alarmLevel" placeholder="选择报警级别">
                        <el-option
                        v-for="item in options1"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                  <div class="public-tit flex align-cen" style="width:100%">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  触发条件设置
                    </div>
                     <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="addtab('triggerList')" v-if="!form.triggerList.length">
                          新增触发条件        
                    </div>
                </div>
              </div>
               <div class="App-tab" v-if="form.triggerList.length" style="width:100%">
                  <el-table
                      :data="form.triggerList"
                      border
                      style="width: 100%"
                      >
                    <el-table-column label="点位名称" align="center">
                        <template slot-scope="scope">
                     <el-select v-model="scope.row.tag" filterable clearable placeholder="选择点位名称" @change="classChange(scope.$index,'triggerList')">
                        <el-option
                        v-for="item in options2"
                        :key="item.id"
                        :label="item.tag + ' ' + item.name"
                        :value="item.tag"
                        >
                        </el-option>
                    </el-select>
                        </template>
                       </el-table-column>
                       <el-table-column label="上限阀值" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.upper" placeholder="请输入上限阀值" clearable
                            oninput="value=value.replace(/^[^\d.]+/g,'')"
                          maxlength="9"
                          minlength="1"
                          >
                          </el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="下限阀值" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.lower" placeholder="请输入下限阀值" clearable
                            oninput="value=value.replace(/^[^\d.]+/g,'')"
                          maxlength="9"
                          minlength="1"
                          >
                          </el-input>
                        </template>
                       </el-table-column>
                       <el-table-column label="持续时间(s)" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.duration" placeholder="请输入持续时间" clearable
                            oninput="value=value.replace(/^[^\d.]+/g,'')"
                                maxlength="9"
                                minlength="1"
                                >
                          </el-input>
                        </template>
                       </el-table-column>
                         <el-table-column label="复合逻辑" align="center">
                        <template slot-scope="scope">
                     <el-select v-model="scope.row.logic" placeholder="选择复合逻辑"
                     :disabled="scope.$index == 0 ? true : false"
                     >
                        <el-option
                        v-for="item in options3"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                        >
                        </el-option>
                    </el-select>
                        </template>
                       </el-table-column>
                        <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                         <el-button type="text" size="small" style="color:red" @click.stop="deltab(scope.row,'triggerList')">删除</el-button>
                        </template>
                       </el-table-column>
                  </el-table>
                    <div class="addtab flex align-cen">
                     <div class="public-btn-small" style="padding:0;width:140px;margin-top:20px">
                     <div class="public-btn-small-primary" @click="addtab('triggerList')">
                          添加触发条件     
                    </div>
                </div>
                  <el-upload
                    class="avatar-uploader flex align-cen"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :limit="1"
                    :show-file-list="true"
                    :on-success="audioSuccess"
                    :before-upload="beforeaudioUpload"
                    v-model="form.audio"
                    ref="upload"
                    style="margin-top:20px;margin-left:20px"
                    >
                       <el-button size="small" type="primary" class="progress-upload-media" v-if="!form.audio">增加报警音频文件</el-button> 
                      <audio v-if="form.audio" :src="form.audio" controls>你的浏览器不支持 <code>audio</code> 标签.</audio></audio>
                      <div class="el-upload__tip icon-al-times-circle" slot="tip" @click="form.audio = ''" v-if="form.audio"></div>
                          </el-upload>
                  </div> 
               </div>
                 <div class="public-tit flex align-cen" style="width:100%;margin-top:20px">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  生效策略
                    </div>
              </div>
               <el-form-item label="自动闭锁：" prop="autoLock">
                <el-radio v-model="form.autoLock" label="1" >开启</el-radio>
                <el-radio v-model="form.autoLock" label="0">关闭</el-radio>
              </el-form-item>
              <el-form-item label="自动闭锁方案："  v-if="form.autoLock == 1" :prop="form.autoLock == 1 ? 'lockTime' : ''" style="width:100%">
                      触发预警后锁定 <el-input v-model="form.lockTime"  clearable style="width:10%"></el-input> 分钟不再检测
                </el-form-item>
                <div class="public-tit flex align-cen" style="width:100%">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  连锁策略
                    </div>
              </div>
               <el-form-item label="连锁条件：" prop="interlock">
                <el-radio v-model="form.interlock" label="1" >开启</el-radio>
                <el-radio v-model="form.interlock" label="0">关闭</el-radio>
              </el-form-item>
              <div class="App-tab" style="width:100%" v-if="form.interlock == 1">
                 <el-table
                      :data="form.interlockList"
                      border
                      style="width: 100%"
                      >
                     <el-table-column label="点位名称" align="center">
                        <template slot-scope="scope">
                     <el-select v-model="scope.row.tag" filterable clearable placeholder="选择点位名称" @change="classChange(scope.$index,'interlockList')">
                        <el-option
                        v-for="item in options2"
                        :key="item.id"
                        :label="item.tag + ' ' + item.name"
                        :value="item.tag"
                        >
                        </el-option>
                    </el-select>
                        </template>
                       </el-table-column>
                        <el-table-column label="连锁数值" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.chainValue" placeholder="请输入连锁数值" clearable
                            oninput="value=value.replace(/^[^\d.]+/g,'')"
                                maxlength="9"
                                minlength="1"
                                >
                          </el-input>
                        </template>
                       </el-table-column>
                          <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                         <el-button type="text" size="small" style="color:red" @click.stop="deltab(scope.row,'interlockList')">删除</el-button>
                        </template>
                       </el-table-column>
                 </el-table>
                   <div class="addtab flex align-cen">
                     <div class="public-btn-small" style="padding:0;width:140px;margin-top:20px">
                     <div class="public-btn-small-primary" @click="addtab('interlockList')">
                          添加连锁条件        
                    </div>
                </div>
                   </div>
              </div>
               <div class="public-tit flex align-cen" style="width:100%">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  自动复位方式
                    </div>
              </div>
                    <el-form-item label="自动复位方式：" prop="resetMode">
                   <el-checkbox-group v-model="checkList" @change="classSelectType">
                        <el-checkbox label="1">手动复位</el-checkbox>
                        <el-checkbox label="2">自动复位</el-checkbox>
                    </el-checkbox-group>
                 </el-form-item>
                   <div class="public-tit flex align-cen" style="width:100%" v-if="checkStatus">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  自动复位条件
                    </div>
              </div>
                    <div class="App-tab" style="width:100%" v-if="checkStatus">
                        <el-table
                      :data="form.resetList"
                      border
                      style="width: 100%"
                      >
                     <el-table-column label="点位名称" align="center">
                        <template slot-scope="scope">
                     <el-select v-model="scope.row.tag" filterable clearable placeholder="选择点位名称" @change="classChange(scope.$index,'resetList')">
                        <el-option
                        v-for="item in options2"
                        :key="item.id"
                        :label="item.tag + ' ' + item.name"
                        :value="item.tag"
                        >
                        </el-option>
                    </el-select>
                        </template>
                       </el-table-column>
                        <el-table-column label="触发条件" align="center" width="150">
                        <template slot-scope="scope">
                           <el-select v-model="scope.row.operate" placeholder="请选择">
                            <el-option
                            v-for="item2 in stepCond1"
                            :key="item2"
                            :label="item2"
                            :value="item2" 
                            >
                            </el-option>
                        </el-select>
                        </template>
                        </el-table-column>
                        <el-table-column label="触发阀值" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.triggerValue" placeholder="请输入触发阀值" clearable
                            oninput="value=value.replace(/^[^\d.]+/g,'')"
                                maxlength="9"
                                minlength="1"
                                >
                          </el-input>
                        </template>
                       </el-table-column>
                          <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                         <el-button type="text" size="small" style="color:red" @click.stop="deltab(scope.row,'resetList')">删除</el-button>
                        </template>
                       </el-table-column>
                 </el-table>
                   <div class="addtab flex align-cen">
                     <div class="public-btn-small" style="padding:0;width:160px;margin-top:20px">
                     <div class="public-btn-small-primary" @click="addtab('resetList')">
                          添加自动复位条件       
                    </div>
                </div>
                   </div>
                    </div>
               </el-form>
            </div>
    </div>
</template>
<script>
import {getAlarmClassify1,instrumentList,editAlarmRule,getAlarmRule} from "@/api/index/index"  //报警分类、点位列表、新增编辑报警规则、报警详情
import debounce from '../../../utils/debounce.js' //防抖
export default {
    data () {
        return {
          checkStatus:false,
          checkList:[],
             headers: {},
            loading:false,
            stepCond1:['=','>','<','>=','<='],
            form:{
                name:'',
                classifyId:'',
                alarmLevel:'',
                audio:'',
                autoLock:'',
                lockTime:'',
                interlock:'',
                triggerList:[],
                resetMode:'',
                interlockList:[
                  {
                   tag:'',
                   name:'',
                   chainValue:''
                  }
                ],
                resetList:[
                  {
                   tag:'',
                   operate:'=',
                   name:'',
                   triggerValue:''
                  }
                ]
            },
            appId:'',
           options:[],
           options2:[],    
           options3:[
            {
                label:'或'
            },
            {
                label:'和'
            }
           ],          
            rules:{
           name: [{ required: true, message: '请输入您的报警规则名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
             ],
            lockTime:[{ required: true, message: '请输入您的自动闭锁方案', trigger: 'blur' }],
          classifyId: [{ required: true, message: '请选择报警分类', trigger: 'change' }],
           alarmLevel: [{ required: true, message: '请选择报警级别', trigger: 'change' }],
           autoLock: [{ required: true, message: '请选择自动闭锁状态', trigger: 'change' }],
            interlock: [{ required: true, message: '请选择连锁条件状态', trigger: 'change' }],
            resetMode: [{ required: false, message: '请选择自动复位方式', trigger: 'change' }],
            },
              options1:[
            {
                id:'4',
                name:'紧急'
            },
            {
                id:'3',
                name:'严重'
            },
            {
                id:'2',
                name:'一般'
            },
            {
                id:'1',
                name:'提示'
            },
           ],
        }
    },
    created() {
        this.getClass()
        if(this.$route.query.id) this.getDetail()
        let token = this.$locaStorage.setAge().get("token");
    if (token) {
      this.headers = {
        Authorization: token,
      };
    }
          
    },
    methods: {
      // 获取报警详情
      getDetail(){
        getAlarmRule({id:this.$route.query.id},'get')
        .then(res =>{
          this.form = {
                name:res.data.name,
                classifyId:res.data.classifyId,
                alarmLevel:res.data.alarmLevel,
                audio:res.data.audio,
                autoLock:res.data.autoLock,
                lockTime:res.data.lockTime,
                interlock:res.data.interlock,
                triggerList:res.data.triggerList,
                resetMode:res.data.resetMode,
                interlockList:res.data.interlockList,
                resetList:res.data.resetList
          }
          this.appId = res.data.appId
          this.checkList = res.data.resetMode.split(',')
          this.checkStatus = res.data.resetMode.includes('2');
          this.getDname(this.appId)
        })
      },
        classSelectType(){
           this.form.resetMode= this.checkList.join(',')
           this.checkStatus = this.form.resetMode.includes('2');
      },
           audioSuccess(res, file, fileList) {
            if (res.code == 0) {
                this.form.audio = res.data.url;
                this.$refs.upload.clearFiles();
            } else {
                this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
                this.$refs.upload.clearFiles();
            }
            },
        // 添加触发条件
        addtab(name){
           if(!this.appId) return this.$util.Notifi('请先选择报警分类','error','fa-exclamation-circle')
           if(name == 'triggerList'){
             this.form.triggerList.push({
                tag:'',
                name:'',
                upper:'',
                duration:'',
                lower:'',
                logic:'',
            })
           }else if(name == 'interlockList'){
               this.form.interlockList.push({
                tag:'',
                name:'',
                chainValue:'',
            })
           }else if(name == 'resetList'){
              this.form.resetList.push({
                tag:'',
                name:'',
                operate:'=',
                triggerValue:'',
            })
           }else{
            
           }
        },
        deltab(data,name){
       let arr = []
          arr.push(data)
        let delet= this.form[name].filter(item=>!arr.some(ele=>ele===item)) 
        if(this.form[name].length == 1){
          this.$message.error('需保留一个')
        }else{
          this.form[name]= delet
        }
        },
        getAppid(e){
            let obj = this.options.find(item => item.id == e);
            this.appId = obj.appId
            this.getDname(this.appId)
        },
        classChange(index,name){
           this.options2.find(item => {
            if( item.tag == this.form[name][index].tag){
                this.form[name][index].name = item.name
            }
           });
        },
        getDname(id){
            instrumentList({appId:id,search:''})
            .then(res =>{
                this.options2 = res.data
            })
        },
        openSteps(formName){
         let params = { ...this.form},
             method = "post"
            if(!this.$route.query.id) params = {...this.form},method = "post";
            if(this.$route.query.id) params = {...this.form,id:this.$route.query.id}, method = "put";
             this.$refs[formName].validate((valid) => {  
                     if(valid){
                    if(!this.form.resetMode) return this.$util.Notifi('请选择自动复位方式','error','fa-exclamation-circle');
                  //防抖提交
                      debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                        }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                }) 
        },
            commentBness(params,method){
               this.loading = true
                editAlarmRule(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id) this.$message.success('新增成功')
                            if(this.$route.query.id) this.$message.success('修改成功')
                                setTimeout(() => {
                           this.$router.push('/AppAlarm')
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
            // 获取报警分类列表
        getClass(){
            getAlarmClassify1({appId:'',name:''})
            .then(res =>{
                this.options = res.data
            })
        },
            beforeaudioUpload(file) {
      if (["audio/mp3", "audio/mpeg"].indexOf(file.type) == -1) {
        this.$util.Notifi(
          "请上传正确的音频格式",
          "error",
          "fa-exclamation-circle"
        );
        return false;
      }
    },
    },
}
</script>
<style lang="scss" scoped>
.edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
         ::v-deep{
          .App-tab{
            .el-select{
              width: 100%;
            }
          }
         }
</style>